module.exports = __webpack_public_path__ + "static/media/menuAddressBook.ac343be3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menuAddressBook.svg
// module id = 486
// module chunks = 0